import { render, staticRenderFns } from "./rainbow-cup.vue?vue&type=template&id=0bfe2369&scoped=true&"
import script from "./rainbow-cup.vue?vue&type=script&lang=js&"
export * from "./rainbow-cup.vue?vue&type=script&lang=js&"
import style0 from "./rainbow-cup.vue?vue&type=style&index=0&id=0bfe2369&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfe2369",
  null
  
)

export default component.exports